window.addEventListener('load', function () {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'JPY',
  });
  this.setTimeout(function () {
    window._swat.fetch(function (r) {
      init(r);
    });
  }, 2000);
  function init(data) {
    if (data && data.length > 0) {
      const remove_all = document.querySelector('.wishlist-deletes');
      remove_all.style.display = 'block';
      remove_all.addEventListener('click', function () {
        deleteAllWishlistProduct(data);
      });
      for (let i = 0; i < data.length; i++) {
        $.getJSON(data[i].du + '.js', function (res) {
          if (res) {
            renderProduct(res, data[i]);
          }
        });
      }
    } else {
      // Render if wishlist if empty
      document.querySelector('.wishlist-empty').style.display = 'block';
    }
  }
  function renderProduct(product, original_data) {
    if (product) {
      // Product wrapper
      const element = document.createElement('div');
      element.className = 'wishlist-item';
      element.setAttribute('data-product-id', product.id);

      // Product thumbnail
      const thumbnail = document.createElement('div');
      thumbnail.className = 'wishlist-thumbnail';
      thumbnail.innerHTML = `<a href="${product.url}"><img class="lazyload" data-src="${product.images[0]}"></a>`;

      // Product title
      const title = document.createElement('div');
      title.className = 'wishlist-title';
      title.innerHTML = `<a href="${product.url}">${product.title}</a>`;

      // Product variants
      const variant = document.createElement('div');
      variant.className = 'wishlist-variant';
      for (let i = 0; i < product.options.length; i++) {
        const child = document.createElement('div');
        let type;
        const name = product.options[i].name.toLowerCase();
        if (name === 'dung lượng') {
          type = 'size';
        } else if (name === 'màu sắc') {
          type = 'color';
        } else if (name === 'color') {
          type = 'color';
        } else {
          type = 'item';
        }
        child.className = 'wishlist-variant-wrap wishlist-variant__' + type;
        for (let n = 0; n < product.options[i].values.length; n++) {
          const variantOption = document.createElement('div');
          variantOption.className = 'wishlist-variant__' + type + '-item';
          variantOption.setAttribute(
            'data-variant-value',
            product.options[i].values[n]
          );
          if (type === 'color') {
            const wc = document.querySelector('.wishlist-container');
            const array_color = wc
              .getAttribute('data-colors')
              .replaceAll('\n', '')
              .trim()
              .split(',');
            let color_found = 0;
            for (let o = 0; o < array_color.length; o++) {
              const data_arr = array_color[o].trim().split(':');
              if (data_arr.length > 1) {
                const color_code = data_arr[1].trim();
                const color_name = data_arr[0];
                if (product.options[i].values[n] === color_name) {
                  variantOption.style.background = color_code;
                  color_found = 1;
                }
              }
            }
            if (color_found === 0) {
              variantOption.style.background =
                product.options[i].values[n].toLowerCase();
            }
          }
          if (product.options[i].values[n] !== 'Default Title') {
            variantOption.innerHTML = product.options[i].values[n];
          }
          child.append(variantOption);
        }
        variant.append(child);
      }

      // Product price
      const price = document.createElement('div');
      price.className = 'wishlist-price';
      price.innerHTML = 'Từ ' + formatter.format(original_data['pr']);

      // Product button
      const button = document.createElement('div');
      button.className = 'wishlist-button';
      const buy_now = document.createElement('a');
      buy_now.setAttribute('href', product.url);
      buy_now.className = 'wishlist-buynow';
      buy_now.innerHTML = 'Mua ngay';
      const del = document.createElement('button');
      del.className = 'wishlist-delete';
      del.setAttribute('type', 'button');
      del.addEventListener('click', function () {
        deleteWishlistProduct(original_data);
      });
      del.innerHTML = 'Xoá';
      button.append(buy_now);
      button.append(del);

      element.append(thumbnail);
      const wrapper = document.createElement('div');

      const div = document.createElement('div');
      const div2 = document.createElement('div');
      div2.append(title);
      div2.append(variant);
      div2.append(price);
      div.append(button);

      wrapper.append(div2);
      wrapper.append(div);

      element.append(wrapper);
      document.querySelector('[data-render-wishlist]').append(element);
    }
  }
  function deleteAllWishlistProduct(data) {
    for (let i = 0; i < data.length; i++) {
      deleteWishlistProduct(data[i]);
    }
    document.querySelector('.wishlist-lists').style.display = 'none';
    document.querySelector('.wishlist-deletes').style.display = 'none';
    document.querySelector('.wishlist-empty').style.display = 'block';
  }
  function deleteWishlistProduct(original_data) {
    if (original_data) {
      window._swat.removeFromWishList(
        {
          epi: original_data.epi,
          du: original_data.du,
          empi: original_data.empi,
          pr: original_data.pr,
          type: 'product-variant',
        },
        function (r) {
          if (r) {
            hiddenWishlistProduct(original_data.empi);
          }
        }
      );
    }
  }
  function hiddenWishlistProduct(product_id) {
    if (product_id) {
      const e = document.querySelector(
        '.wishlist-item[data-product-id="' + product_id + '"]'
      );
      if (e) {
        e.style.display = 'none';
      }
    }
  }
});
